import React from 'react'
import PropTypes from 'prop-types'
import { StyleSheet, css } from 'aphrodite'
import UISubtitle from '../components/UI/UISubtitle'
import UIButton from '../components/UI/UIButton'
import { useTranslation } from 'react-i18next'
import { COLOR_BLACK } from '../lib/colors'

const styles = StyleSheet.create({
  button: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: '5px',
    margin: '15px 0px 0px 0px',
  },
  modalMessage: {
    fontWeight: '600',
    fontSize: 14,
    lineHeight: '24px',
    textAlign: 'center',
    color: COLOR_BLACK,
  },
  modalContainer: {
    maxWidth: '400px',
  },
  content: {
    textAlign: 'justify',
    fontSize: '13px',
  },
})

function ConfirmationDeleteCommandPopup({
  title,
  message,
  content,
  closeToast,
  handleConfirm,
  id,
}) {
  const { t } = useTranslation('translation')

  return (
    <div className={css(styles.modalContainer)}>
      {title && <UISubtitle label={title} />}
      <p className={css(styles.modalMessage)}>{message}</p>
      <p
        className={css(styles.content)}
        dangerouslySetInnerHTML={{ __html: `${content}` }}
      />
      <div className={css(styles.button)}>
        <UIButton
          kind="button"
          design="primary"
          type="submit"
          smaller={true}
          label={`${t('common.button.confirm')}`}
          onClick={() => handleConfirm(id)}
          fullWidth={true}
        />
        <UIButton
          kind="button"
          design="invertedPrimary"
          smaller={true}
          label={`${t('common.button.cancel')}`}
          onClick={closeToast}
          fullWidth={true}
        />
      </div>
    </div>
  )
}

ConfirmationDeleteCommandPopup.propTypes = {
  title: PropTypes.string,
  message: PropTypes.string,
  closeToast: PropTypes.func,
  handleConfirm: PropTypes.func,
  id: PropTypes.id,
  content: PropTypes.string,
}

export default ConfirmationDeleteCommandPopup
